import React from "react";
import { useNavigate } from "react-router-dom";
import { encrypt2 } from "../../../../utils/encrypt";
import { RouteLinks } from "../../../../routes/RouteLinks";
import { lowerCaseWrap } from "../../../../helper";
import Skeleton from "react-loading-skeleton";
import {
  RavenBadge,
  RavenCopyText,
  RavenNumberFormat,
  RavenTextTrim,
  RavenToolTip,
} from "@ravenpay/raven-bank-ui";
import Icons from "../../../../assets/icons/icons";
import { colorToRgba } from "../../../../utils/helpers";

interface MyComponentProps {
  serial?: string;
  loading?: boolean;
  tid_label?: string;
  tid?: string;
  status?: string;
  details?: any;
}

const TerminalCardComponent = ({
  serial,
  loading,
  tid_label,
  tid,
  status,
  details,
}: MyComponentProps) => {
  const navigate = useNavigate();

  const trimNum = 45;

  return (
    <div
      className="terminal-boxes-wrap grey-bg"
      onClick={async () => {
        const encryptedSerial = await encrypt2(serial ?? "");
        localStorage?.setItem("takwoski", encryptedSerial);
        navigate(RouteLinks?.Terminal_details);
      }}
      style={{
        minWidth: "32rem",
      }}
    >
      {/* top serial  box start */}
      <div className="top-serial-box-wrap">
        {/* <div className="img-terminal">
    {loading ? (
      <Skeleton width={35} height={35} circle />
    ) : (
      <figure className="img-box">
        <img src={smallTerminalImg} alt="" className="img" />
      </figure>
    )}
  </div> */}
        <div className="terminal-serial-box-box">
          {loading ? (
            <Skeleton
              width={70}
              height={17}
              style={{ marginBottom: ".3rem" }}
            />
          ) : (
            <p className="terminal">{lowerCaseWrap(tid_label) || "---"}</p>
          )}
          {loading ? (
            <Skeleton width={200} height={11} />
          ) : (
            <div className="serial grey-white-color tooltip-hover-wrap ">
              <span>
                <RavenCopyText
                  trimNum={trimNum}
                  text={`Serial No: ${serial}`}
                  copyValue={serial}
                  stopPropagation
                  color="deep-green-light"
                  copyIconColor="var(--primary-base-color)"
                  copyIconBgColor={colorToRgba(
                    "var(--primary-base-color)",
                    0.1
                  )}
                  copiedBgColor=" var(--primary-base-color)"
                />
              </span>
            </div>
          )}
        </div>
      </div>
      {/* top serial  box end */}

      <div className="bottom-value-boxed card-bg grey-white-color">
        {loading ? (
          <Skeleton width={100} height={22} />
        ) : (
          <div className="bottom-value-box-inner ">
            <div className="bottom-value-box-inner-top">
              <div className="img-and-text-box-wrapper">
                <div className="img-terminal grey-bg">
                  <figure className="img-box">{Icons.tidIcon}</figure>
                </div>
                <p className="assignee-box">
                  TID : <span>{tid}</span>
                </p>
              </div>

              <div className="status-and-three-dots">
                <div className="value">
                  <RavenBadge
                    type={
                      Number(status) === 1
                        ? `green`
                        : Number(status) === 2
                        ? "red"
                        : ""
                    }
                    text={
                      Number(status) === 1
                        ? "Active"
                        : Number(status) === 2
                        ? "Deactivated "
                        : ""
                    }
                  />
                </div>
                <div className="img-terminal grey-bg">
                  <figure className="img-box ">{Icons.threeDot}</figure>
                </div>
              </div>
            </div>

            <div className="amount-and-volume-box">
              <p className="volume-count"> Volume in the last 30 Days</p>
              <p className="amount">
                {RavenNumberFormat(details?.volume_in_30_days) || "0.00"}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TerminalCardComponent;
